import CreateSequenceNumberRequestModelBase from '../_generated/modelBases/create-sequence-number-request-model-base';

export default class CreateSequenceNumberRequestModel extends CreateSequenceNumberRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
